import { setUser } from '../admin/redux/actions/authActions';
import { setUser as setUserSlice } from '../store/slices/userSlice';
import { isTokenExpired, clearAuthState } from './tokenUtils';

export const initializeAuth = (store) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const userData = sessionStorage.getItem('user');
    
    if (token && userData) {
      // Check if token is expired
      if (isTokenExpired(token)) {
        // Token expired, clear everything
        clearAuthState();
        return;
      }
      
      const parsedUser = JSON.parse(userData);
      if (parsedUser && (parsedUser._id || parsedUser.id)) {
        // Normalize user data structure
        const normalizedUser = {
          ...parsedUser,
          _id: parsedUser._id || parsedUser.id,
          id: parsedUser.id || parsedUser._id
        };
        
        // Initialize both Redux stores with token
        store.dispatch(setUser(normalizedUser));
        store.dispatch(setUserSlice(normalizedUser));
        
        // Update auth reducer with token
        store.dispatch({
          type: 'LOGIN_SUCCESS',
          payload: { user: normalizedUser, token }
        });
      }
    }
  } catch (error) {
    console.error('Error initializing auth state:', error);
    // Clear invalid data
    clearAuthState();
  }
};